import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import DatePicker from "react-datepicker";
const ProjectHoldToActiveModal = ({
  show,
  onConfirm,
  onCancel,
  isLoading,
  project,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);

  const handleConfirm = () => {
    if (selectedDate) {
      onConfirm(selectedDate);
    }
  };

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      setSelectedDate(null);
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  if (!show) return null;

  return (
    <>
      <div className="modal fade show" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <p className="modal-title fw-600 fs-6">Select Active Date</p>
              <button
                type="button"
                className="btn-close"
                onClick={onCancel}
                style={{ filter: "invert(0.3)" }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row mb-3 align-items-center justify-content-center">
                <div className="col-md-2 text-end">
                  <label className="form-label mb-0" style={{ color: "#333" }}>
                    Date *
                  </label>
                </div>
                <div className="col-md-6">
                  <DatePicker
                    showIcon
                    toggleCalendarOnIconClick
                    placeholderText="mm/dd/yyyy"
                    dateFormat="MM-dd-yyyy"
                    selected={selectedDate}
                    className="border custom-date"
                    onChange={(date) => setSelectedDate(date)}
                    minDate={
                      project.sowStartDate
                        ? new Date(project.sowStartDate)
                        : null
                    }
                    maxDate={
                      project.sowEndDate
                        ? new Date(
                            Math.min(new Date(project.sowEndDate), new Date())
                          )
                        : new Date()
                    }
                    required
                    onKeyDown={(e) => {
                      if (e.key !== "Backspace" && e.key !== "Delete") {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className={`theme-button ${
                  isLoading || !selectedDate ? "disabled" : ""
                }`}
                onClick={handleConfirm}
                disabled={isLoading || !selectedDate}
              >
                {isLoading ? (
                  <ThreeDots height="20" width="100" color="white" />
                ) : (
                  "Confirm"
                )}
              </button>
              <button
                type="button"
                className="theme-button bg-grey mx-3"
                onClick={onCancel}
                disabled={isLoading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ProjectHoldToActiveModal;
